import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../../../../../react-core/Flux/Dispatcher";
import { FluxResponse } from "../../../../../../../Shared/Stores/FluxResponse";
import { InvestmentRegionAllocationModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/InvestmentRegionAllocationModel";
import { InsightsStoreStatic, InvestmentRegionAllocationStatic } from "./InsightsStoreStatic";
import { InvestmentGeographicAllocationModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/InvestmentGeographicAllocationModel";

export interface RegionGroupFluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
    otherObj?: any;
}
// RegionCode dispatcher
export const InsightsDispatcher: Dispatcher<RegionGroupFluxResponse> = new Dispatcher<RegionGroupFluxResponse>();
export const InsightsStore: InsightsStoreStatic = new InsightsStoreStatic();

// InvestmentRegionAllocation dispatcher
export const InvestmentRegionAllocationDispatcher: Dispatcher<FluxResponse<
    Array<InvestmentRegionAllocationModel>
>> = new Dispatcher<FluxResponse<Array<InvestmentGeographicAllocationModel>>>();
export const InvestmentRegionAllocationStore: InvestmentRegionAllocationStatic = new InvestmentRegionAllocationStatic();
